import gql from 'graphql-tag';

export const reportGames = gql`
	query listGames(
		$sortDirection: SortDirection
		$limit: Int
		$startTime: String
		$endTime: String
		$nextToken: String
		$filter: ListGamesFilterInput
	) {
		listGames(sortDirection: $sortDirection, limit: $limit, startTime: $startTime, endTime: $endTime, nextToken: $nextToken, filter: $filter) {
			items {
				id
				sport
				startTime
				status
				title
				league {
					id
					name
					sport
				}
				highlights(sortDirection: DESC) {
					items {
						id
						periods {
							items {
								id
								title
							}
						}
						type
					}
				}
				airings {
					items {
						id
						channel {
							name
						}
						status
						alternateIds {
							items {
								id
								namespace
							}
						}
						exclusionPlayIds
					}
				}
				excludeScheduling
			}
			nextToken
		}
	}
`;
